import { render, staticRenderFns } from "./RespUserPersistView.vue?vue&type=template&id=8214f3c2"
import script from "./RespUserPersistView.vue?vue&type=script&lang=ts"
export * from "./RespUserPersistView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports